import React from "react";
import ReferralStats from "../components/dashboard/ReferralStats";
import PaymentHistory from "../components/dashboard/PaymentHistory";
import { useAuth } from "../context/AuthContext";

const DashboardPage = () => {
  const { user } = useAuth();

  return (
    <div className="dashboard-page">
      <header className="dashboard-page__header">
        <h1>Bienvenido {user?.first_name || ""}!</h1>
        <p className="dashboard-page__subtitle">
          Aquí tienes un resumen de tu actividad
        </p>
      </header>

      <div className="dashboard-page__content">
        <ReferralStats />
        <PaymentHistory />
      </div>
    </div>
  );
};

export default DashboardPage;
